import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export enum AudioPlaybackStatus {
   PLAYING = "playing",
   FINISHED = "finished",
}

export interface AudioPlaybackState {
   playingAlertId: string | null
   playingAlertPriority: number | null
   status: AudioPlaybackStatus
   isSoundEnabled: boolean
}

export const initialState: AudioPlaybackState = {
   playingAlertId: null,
   playingAlertPriority: null,
   status: AudioPlaybackStatus.FINISHED,
   isSoundEnabled: false,
}

const audioPlaybackSlice = createSlice({
   name: "audioPlayback",
   initialState,
   reducers: {
      // Sound stays enabled after an alarm, so the tap prompt doesn't come back.
      resetAudioPlayback: (state) => ({
         ...initialState,
         isSoundEnabled: state.isSoundEnabled,
      }),
      setPlayingAlertId(state, action: PayloadAction<string | null>) {
         state.playingAlertId = action.payload
      },
      setPlayingAlertPriority(state, action: PayloadAction<number | null>) {
         state.playingAlertPriority = action.payload
      },
      setPlaybackStatus(state, action: PayloadAction<AudioPlaybackStatus>) {
         state.status = action.payload
      },
      setSoundEnabled(state, action: PayloadAction<boolean>) {
         state.isSoundEnabled = action.payload
      },
   },
})

export const {
   resetAudioPlayback,
   setPlayingAlertId,
   setPlayingAlertPriority,
   setPlaybackStatus,
   setSoundEnabled,
} = audioPlaybackSlice.actions
export default audioPlaybackSlice.reducer
